import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-13 ant-col-xl-13" }
const _hoisted_5 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_6 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-3 ant-col-xl-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Código")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-12 ant-col-xl-12" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Centro de Custo")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-6 ant-col-xl-6" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Proporção")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-3 ant-col-xl-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações")
  ])
], -1)
const _hoisted_8 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_9 = { class: "ss-margin-campos" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_12 = { class: "ss-margin-campos" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_15 = { class: "ss-margin-campos" }
const _hoisted_16 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_17 = { class: "ss-margin-campos" }
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_centro_custo = _resolveComponent("selecionar-centro-custo")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    "wrap-class-name": "ss-modal-cadastros"
  }, {
    title: _withCtx(() => [
      _createTextVNode("Centros de Custo")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmar()))
        }, _hoisted_2)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_form_item, {
                label: "Centro de Custo",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_selecionar_centro_custo, {
                    codigoSelecionado: _ctx.state.centroCustoSelecionado,
                    "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.centroCustoSelecionado) = $event)),
                    descricaoSelecionado: _ctx.state.descricaoCentroCustoSelecionado,
                    "onUpdate:descricaoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.descricaoCentroCustoSelecionado) = $event)),
                    ignorarCentroCustos: _ctx.state.centrosCusto.map(c=>c.codigoCentroCusto)
                  }, null, 8, ["codigoSelecionado", "descricaoSelecionado", "ignorarCentroCustos"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_form_item, {
                label: "Proporção",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_campo_numerico, {
                    valor: _ctx.state.proporcao,
                    "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.proporcao) = $event)),
                    percentual: true
                  }, null, 8, ["valor"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_form_item, {
                label: " ",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-primary",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.adicionarCentroCusto()))
                  }, "Adicionar")
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_7,
          (_ctx.state.centrosCusto.length <= 0)
            ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                key: 0,
                mensagem: "Nenhum centro de custo adicionado ainda"
              }))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.state.centrosCusto, (centroCusto, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "ant-row ss-grade-personalizada-linha",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        value: centroCusto.codigoCentroCusto,
                        disabled: ""
                      }, null, 8, _hoisted_10)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        value: centroCusto.descricaoCentroCusto,
                        disabled: ""
                      }, null, 8, _hoisted_13)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_campo_numerico, {
                        valor: _ctx.state.centrosCusto[index].proporcao,
                        "onUpdate:valor": ($event: any) => ((_ctx.state.centrosCusto[index].proporcao) = $event),
                        percentual: true
                      }, null, 8, ["valor", "onUpdate:valor"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ant-btn ant-btn-primary ant-btn-dangerous ss-botao-remover",
                        title: "Remover",
                        onClick: ($event: any) => (_ctx.removerCentroCusto(index))
                      }, [
                        _createVNode(_component_icone, {
                          class: "ss-icone-remover",
                          nome: "excluir"
                        })
                      ], 8, _hoisted_18)
                    ])
                  ])
                ]))
              }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}